import type { MilkdownPlugin } from '@milkdown/kit/ctx';

import { platformImageBlockDimensionSync } from './dimensionSyncPlugin';
import { platformLiftInlineImages } from './liftInlineImages';
import { remarkPlatformImageBlockDimensions } from './remarkPlugin';
import { platformImageBlockSchema } from './schemaExtension';

export const platformImageBlockPlugins = [
  remarkPlatformImageBlockDimensions,
  platformImageBlockSchema,
  platformLiftInlineImages,
  platformImageBlockDimensionSync,
].flat() as unknown as MilkdownPlugin[];
